const DEVICE_KEY = 'plain-sight-census.v1.deviceKey';

export function getOrCreateDeviceKey(): string {
  const existing = localStorage.getItem(DEVICE_KEY);
  if (existing) return existing;
  const key = crypto.randomUUID() + ':' + Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, '0')).join('');
  localStorage.setItem(DEVICE_KEY, key);
  return key;
}

export async function deviceHash(): Promise<string> {
  const data = new TextEncoder().encode(getOrCreateDeviceKey());
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}
